import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Caesars_&_SA2_Hotels.webp';

const Project_one = () => {

  return (
    <>
        
              <div className='project_1_work' id="workBanner">
        
                <div className="container project_our_work">
        
                  <div className="heading">
                    <h1>Caesars Hotel Bluewaters</h1>
                  </div>
        
                  <hr></hr>
                  <div className='project_section'>
                    <div className="project_section_content">
                      <h1 className="project_scope">Scope of Work</h1>
                      <p>A luxury hotel marking Caesars Palace's first presence in the Middle East, located on Bluewaters Island adjacent to the Ain
                        Dubai observation wheel. Part of the Meraas-developed Bluewaters mixed-use destination.</p>
                      <p>MAIN CONTRACTOR : -</p>
                      <p>MEP CONTRACTOR : JLW</p>
                      <p>GEMCO SCOPE OF WORKS : CHW works</p>
                      {/* <h2 className="project_years">2014 – 2022</h2> */}
                    </div>
                    <div className='project_1_card'>
                      <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                    </div>
                  </div>
                </div>
              </div>
        
            </>

  )
}

export default Project_one